<ng-container *transloco="let t; read: 'companies.settings'">
  <h2 class="padding-bottom-medium">{{ t('title') }}</h2>
  @if (form) {
    <form [formGroup]="form" (submit)="onSubmit()">
      <!-- plain wrapper: kendo-formfield requires exactly one form control and throws in dev mode otherwise -->
      <div class="k-form-field flexColumn">
        <span class="tooltipContainer">
          <kendo-label [text]="isInventoryEnabled ? t('inventoryEnabledYes') : t('inventoryEnabledNo')">
            <span [attr.tooltip]="t('inventoryEnabledHint')" flow="right" class="tooltipContainer">
              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
            </span>
          </kendo-label>
        </span>
        <a class="toggleActiveLink" role="button" tabindex="0"
          (click)="toggleInventoryEnabled()"
          (keydown.enter)="toggleInventoryEnabled()">
          {{ isInventoryEnabled ? t('deactivate') : t('activate') }}
        </a>
      </div>
      <div class="buttonContainer">
        <button
          kendoButton
          class="buttonPrimary"
          type="submit"
          [disabled]="form.invalid || !form.dirty || saving">
          {{ t('save') }}
        </button>
      </div>
    </form>
  }
</ng-container>